<div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">Course Listing Preview</h3>
    <button mat-icon-button class="close-btn" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </button>
</div>


<mat-dialog-content class="dialog-scroll-wrapper"
    style="background-color: rgb(247, 248, 250);scrollbar-width:none !important;margin: 0px !important;">
    <!-- 
    <div class="wrapper">
        <section class="banner-container" style="border-radius: 20px;margin-bottom: 10px;"
            *ngIf="coursePreview?.course_banner_video?.length">
            <div class="banner-swiper">
                <div class="banner-wrapper" style="background-color: transparent;">



                    <swiper [config]="headerBannerSwiperConfig" class="banner-swiper">
                        <div *ngFor="let banner of coursePreview?.course_banner_video" class="swiper-slide">
                            <div class="banner-wrapper" style="background-color: transparent;">



                                <img *ngIf="banner?.type?.startsWith('image/')" class="banner-image"
                                    style="border-radius: 20px;" [src]="banner?.url" />

                                <video *ngIf="banner?.type?.startsWith('video/')" class="banner-image" controls muted
                                    playsinline preload="metadata">
                                    <source [src]="banner?.url" type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>

                            </div>
                        </div>

                        <div class="swiper-pagination"></div>
                    </swiper>

                </div>


            </div>
        </section>
    </div> -->

    <div class="wrapper">
        <section class="banner-container" style="border-radius: 20px;"
            *ngIf="coursePreview?.course_banner_image?.length">
            <div class="banner-swiper">
                <div class="banner-wrapper" style="padding: 20px 0;border-radius: 20px;">

                    <!-- <img src="../../../../../assets/images/ban-directory.jpg" class="banner-image" style="border-radius: 20px;" [src]="" /> -->

                    <swiper [config]="headerBannerSwiperConfig" class="banner-swiper">
                        <div *ngFor="let banner of coursePreview?.course_banner_image" class="swiper-slide">
                            <div class="banner-wrapper">

                                <!-- <ng-container [ngSwitch]="banner.type"> -->

                                <img class="banner-image" style="border-radius: 20px;" [src]="banner?.url" />
                                <!-- <img *ngIf="banner?.type?.startsWith('image/')" class="banner-image" style="border-radius: 20px;" [src]="banner?.url"     /> -->

                                <!-- <img *ngSwitchCase="'image'" [src]="banner.url" alt="banner image" /> -->

                                <!-- <video #bannerVideo *ngIf="banner?.type?.startsWith('video/')"  class="banner-image"   autoplay muted loop  preload="metadata">
                  <source [src]="banner?.url" type="video/mp4" />
                  Your browser does not support the video tag.
                </video> -->


                                <!-- </ng-container> -->

                            </div>
                        </div>

                        <div class="swiper-pagination"></div>
                    </swiper>

                </div>


            </div>
        </section>
    </div>

    <div class="wrapper">
        <div class="full-white-background">

            <div class="job-details-page">
                <div class="job-details-page__container">

                    <!-- Main Content -->
                    <!-- <main class="job-details-content"
                        *ngIf="coursePreview?.course_name || coursePreview?.presented_by_name || coursePreview?.startDate || coursePreview?.cpd_points || coursePreview?.type || coursePreview?.afterwards_price && coursePreview?.early_bird_price || coursePreview?.course_banner_image?.length || coursePreview?.learning_objectives || coursePreview?.description || coursePreview?.event_type || coursePreview?.sponsor_by_image?.length || coursePreview?.terms || coursePreview?.address || coursePreview?.contact_email || coursePreview?.contact_phone || coursePreview?.contact_website"> -->
                    <!-- ...existing code... -->
                    <main class="job-details-content" *ngIf="hasCourseData; else noData">

                        <div class="header-details" *ngIf="coursePreview?.course_name">

                            <span class="head-title"> {{coursePreview?.course_name}} </span> <span
                                class="head-title-sub"> A
                                Comprehensive Guide</span>

                        </div>
                        <hr *ngIf="coursePreview?.course_name">

                        <div class="presenter-container">
                            <div class="presenter-info"
                                *ngIf="coursePreview?.presented_by_image || coursePreview?.presented_by_name">
                                <span class="label">Presented by</span>

                                <div style="display: flex;align-items: center;gap: 10px;">
                                    <div class="presenter-image" *ngIf="coursePreview?.presented_by_image">
                                        <img *ngIf="coursePreview?.presented_by_image?.url"
                                            [src]="coursePreview?.presented_by_image?.url" />
                                    </div>
                                    <div *ngIf="coursePreview?.presented_by_name">
                                        <span class="name"> {{coursePreview?.presented_by_name}}</span>

                                    </div>
                                </div>

                            </div>

                            <div style="display: flex;flex-direction: column;gap: 10px;">
                                <ng-container *ngIf="coursePreview?.startDate && coursePreview?.endDate">
                                    <div class="date-info">
                                        <mat-icon class="calendar-icon">event</mat-icon>
                                        <div class="time-range">
                                            {{ formattedDateRange }}
                                        </div>
                                    </div>

                                </ng-container>

                                <ng-container *ngIf="coursePreview?.startTime && coursePreview?.endTime">
                                    <div class="date-info">
                                        <mat-icon class="calendar-icon" aria-hidden="true">access_time</mat-icon>
                                        <span class="time-range">
                                            {{ coursePreview?.startTime | date:'hh:mm a' }}
                                            &nbsp;–&nbsp;
                                            {{ coursePreview?.endTime | date:'hh:mm a' }}
                                        </span>
                                    </div>

                                </ng-container>

                                <ng-container *ngIf="coursePreview?.rsvp_date">
                                    <div class="date-info">
                                        <span style="color: #ff7a00;">RSVP &nbsp;–&nbsp;</span>
                                        <!-- <mat-icon class="calendar-icon">event</mat-icon> -->
                                        <span class="time-range">{{ formattedRsvpDate }}</span>
                                    </div>
                                </ng-container>

                            </div>


                        </div>

                        <hr *ngIf="coursePreview?.presented_by_name || coursePreview?.startDate">
                        <!-- course -- info -->

                        <div class="info-container"
                            *ngIf="coursePreview?.cpd_points || coursePreview?.type || coursePreview?.afterwards_price && coursePreview?.early_bird_price">

                            <div class="info-data" style=" justify-content: flex-start;-items: flex-start;"
                                *ngIf="coursePreview?.cpd_points">
                                <div class="info-item">
                                    <div class="info-title">CPD HOURS</div>
                                    <div class="info-value">{{coursePreview?.cpd_points}}</div>
                                </div>
                            </div>

                            <div class="divider"></div>

                            <div class="info-data">
                                <div class="info-item">
                                    <div class="info-title">WHERE</div>
                                    <div class="info-value" *ngIf="!coursePreview?.address">Online</div>
                                    <div class="info-value">{{coursePreview?.city }}</div>
                                </div>
                            </div>

                            <div class="divider" *ngIf="coursePreview?.type"></div>

                            <div class="info-data" *ngIf="coursePreview?.type">
                                <div class="info-item">
                                    <div class="info-title">HOW</div>
                                    <div class="info-value">{{coursePreview?.type}}</div>
                                </div>
                            </div>

                            <div class="divider"
                                *ngIf="coursePreview?.afterwards_price && coursePreview?.early_bird_price">
                            </div>

                            <div class="info-data" style=" justify-content: flex-end;-items: flex-end;"
                                *ngIf="coursePreview?.afterwards_price && coursePreview?.early_bird_price">
                                <div class="info-item">
                                    <div class="info-title">PRICE</div>
                                    <div class="info-value">
                                        <ng-container *ngIf="earlybidPrice(coursePreview); else afterwardsPrice">
                                            <span class="old-price">$ {{ coursePreview?.afterwards_price }}</span>
                                            <span class="new-price">$ {{ coursePreview?.early_bird_price }}</span>
                                        </ng-container>
                                        <ng-template #afterwardsPrice>
                                            <span class="new-price">$ {{ coursePreview?.afterwards_price }} </span>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>

                        </div>


                        <!-- course video -->
                        <div class="banner-course-img" style="margin-top: 20px;">

                            <div class="swiper-container" *ngIf="coursePreview?.course_banner_video?.length">
                                <swiper [config]="bannerSwiperConfig">
                                    <div *ngFor="let img of coursePreview?.course_banner_video" class="swiper-slide">

                                        <img *ngIf="img?.type?.startsWith('image/')" [src]="img?.url" alt="Slide image"
                                            loading="lazy" />


                                        <div *ngIf="img?.type?.startsWith('video/')" class="video-container">

                                            <video #bannerVideo *ngIf="img?.type?.startsWith('video/')" class=""
                                                autoplay muted loop preload="metadata">
                                                <source [src]="img?.url" type="video/mp4" />
                                                Your browser does not support the video tag.
                                            </video>

                                        </div>



                                    </div>
                                    <div class="swiper-pagination"></div>
                                </swiper>

                            </div>
                        </div>



                        <!-- Objective and topics include -->

                        <div class="obj-topics">

                            <div class="objective"
                                *ngIf="coursePreview?.learning_objectives || coursePreview?.description">
                                <div>

                                    <h3 class="section-title"> Course Description </h3>

                                    <div class="underline-wrapper">
                                        <div class="underline-orange"></div>
                                        <div class="underline-grey"></div>
                                    </div>

                                    <p class="bio" *ngIf="coursePreview?.learning_objectives">
                                        {{ coursePreview?.learning_objectives }}
                                    </p>

                                    <p class="bio" *ngIf="coursePreview?.description">
                                        {{ coursePreview?.description }}
                                    </p>
                                </div>

                                <div class="event-image" *ngIf="coursePreview?.course_gallery?.length">
                                    <swiper [config]="gallerySwiperConfig">
                                        <div *ngFor="let eventimg of coursePreview?.course_gallery"
                                            class="swiper-slide">
                                            <img [src]="eventimg?.url" alt="eventImg" />
                                        </div>


                                    </swiper>
                                </div>

                            </div>


                            <div class="topics-include" *ngIf="coursePreview?.topics_included">
                                <h3 class="section-title">Topics Include</h3>

                                <div class="underline-wrapper">
                                    <div class="underline-orange"></div>
                                    <div class="underline-grey"></div>
                                </div>

                                <p class="bio">
                                    {{ coursePreview?.topics_included }}
                                </p>
                            </div>




                        </div>


                        <!-- course-informarion -->

                        <div class="course-information">

                            <div class="section-title"> {{coursePreview?.event_type}} Day Event </div>
                            <div class="underline-wrapper">
                                <div class="underline-orange"></div>
                                <div class="underline-grey"></div>
                            </div>
                            <div class="course-details"
                                *ngFor="let event of coursePreview?.course_event_info; let i = index">

                                <div class="event-info">
                                    <div class="event-title" *ngIf="coursePreview?.event_type === 'single' ">
                                        {{event?.name}} </div>
                                    <div class="event-title" *ngIf="coursePreview?.event_type === 'multiple' "> <span
                                            style="color: #ff7a00;font-size:18px"> Day{{i + 1 }}:</span> <span>
                                            {{event?.name}} </span> </div>

                                    <p class="bio"> {{ event?.info}} </p>

                                </div>

                                <div class="event-image" *ngIf="event?.images">
                                    <swiper [config]="eventSwiperConfig">
                                        <div *ngFor="let eventimg of event?.images" class="swiper-slide">
                                            <img [src]="eventimg?.url" alt="eventImg" />
                                        </div>


                                    </swiper>
                                </div>


                            </div>

                        </div>


                        <!-- Sponsored By -->

                        <div class="sponsored-by" *ngIf="coursePreview?.sponsor_by_image?.length">
                            <div class="section-title">Sponsored By</div>

                            <div class="underline-wrapper">
                                <div class="underline-orange"></div>
                                <div class="underline-grey"></div>
                            </div>

                            <ng-container *ngIf="coursePreview?.sponsor_by_image.length">
                                <marquee behavior="scroll" direction="left" scrollamount="6">

                                    <ng-container *ngFor="let SponsorImg of coursePreview?.sponsor_by_image">
                                        <img style="height: 150px;width: 150px;" [src]="SponsorImg?.url"
                                            alt="Sponsor" />
                                        <span style="display: inline-block; width: 30px;"></span>
                                    </ng-container>

                                </marquee>
                            </ng-container>


                        </div>






                        <!-- Terms and conditions -->

                        <div class="terms-conditions" *ngIf="coursePreview?.terms">
                            <div class="section-title">Terms and Conditions</div>
                            <div class="underline-wrapper">
                                <div class="underline-orange"></div>
                                <div class="underline-grey"></div>
                            </div>

                            <p class="bio">
                                {{ coursePreview?.terms }}
                            </p>


                        </div>

                        <!-- Cancellation & Refund Policy -->


                        <div class="terms-conditions" *ngIf="coursePreview?.terms">
                            <div class="section-title">Cancellation & Refund Policy</div>
                            <div class="underline-wrapper">
                                <div class="underline-orange"></div>
                                <div class="underline-grey"></div>
                            </div>

                            <p class="bio">
                                {{ coursePreview?.refund_policy}}
                            </p>


                        </div>


                        <!-- contacts -->

                        <div id="location" class="location-container" style="padding-top:30px;"
                            *ngIf="coursePreview?.address || coursePreview?.contact_email || coursePreview?.contact_phone || coursePreview?.contact_website">

                            <div class="section-title">Get in Touch</div>

                            <div class="underline-wrapper">
                                <div class="underline-orange"></div>
                                <div class="underline-grey"></div>
                            </div>


                            <div class="location-data">

                                <div class="contact-wrapper">
                                    <!-- Contact Info -->
                                    <div class="contact-info">


                                        <!-- Webinar Host / Name -->
                                        <div class="info-block" *ngIf="coursePreview?.contact_name">
                                            <div class="icon-circle">
                                                <i class="fas fa-user" style="color:white;"></i>
                                            </div>
                                            <span class="socialLink">
                                                {{ coursePreview.contact_name }}
                                            </span>
                                        </div>


                                        <div class="info-block" *ngIf="coursePreview?.contact_email">
                                            <div class="icon-circle">
                                                <img src="../../../../../assets/images/icons/mail-directory.png"
                                                    alt="Email Icon" class="icon" />
                                            </div>
                                            <p> {{coursePreview?.contact_email}} </p>
                                        </div>

                                        <div class="info-block" *ngIf="coursePreview?.contact_phone ">
                                            <div class="icon-circle">
                                                <img src="../../../../../assets/images/icons/call-directory.png"
                                                    alt="Phone Icon" class="icon" />
                                            </div>
                                            <p> {{coursePreview?.contact_phone}}</p>
                                        </div>



                                        <div class="info-block" *ngIf="coursePreview?.contact_website">
                                            <div class="icon-circle">
                                                <i style="color: white;" class="fas fa-globe"></i>
                                            </div>
                                            <a class="socialLink" href="https://www.example.com " target="_blank">
                                                {{coursePreview?.contact_website}}
                                            </a>

                                        </div>

                                        <!-- Registration Link -->
                                        <div class="info-block" *ngIf="coursePreview?.register_link">
                                            <div class="icon-circle">
                                                <i class="fas fa-clipboard-check" style="color:white;"></i>
                                            </div>
                                            <a class="socialLink" [href]="coursePreview.register_link" target="_blank">
                                                {{ coursePreview.register_link }}
                                            </a>
                                        </div>


                                        <!-- Webinar Meeting Link -->
                                        <div class="info-block" *ngIf="coursePreview?.webinar_link">
                                            <div class="icon-circle">
                                                <i class="fas fa-video" style="color:white;"></i>
                                            </div>
                                            <a class="socialLink" [href]="coursePreview.webinar_link" target="_blank">
                                                {{ coursePreview.webinar_link }}
                                            </a>
                                        </div>

                                        <div class="info-block" *ngIf="coursePreview?.address">
                                            <div class="icon-circle">
                                                <img src="../../../../../assets/images/icons/location-directory.png"
                                                    style="height: 20px !important; width: 16px;" alt="Location Icon"
                                                    class="icon" />
                                            </div>
                                            <p> {{coursePreview?.address}}</p>
                                        </div>



                                    </div>

                                    <!-- Map -->
                                    <div class="map-section" *ngIf="coursePreview?.address">
                                        <agm-map [latitude]="lat" [longitude]="lng">
                                            <agm-marker [latitude]="lat" [longitude]="lng"></agm-marker>
                                        </agm-map>
                                    </div>

                                </div>

                            </div>




                        </div>


                    </main>

                    <ng-template #noData>
                        <div class="no-preview" style="width: 100%;text-align: center;">
                            <img src="../../../../../assets/images/empty-imgs/no_data.gif" alt="No Preview Data" />
                            <p class="mt-4">No preview data available</p>
                        </div>
                    </ng-template>

                </div>
            </div>
        </div>

    </div>





</mat-dialog-content>